import { REACT_COMP_VERSION } from '../constants.js';
import { Logger } from '../logger.js';

var addScriptsToDocument = function (scripts) {
    scripts.forEach(function (scriptObj) {
        var scriptElement = document.createElement("script");
        if (scriptObj.src)
            scriptElement.src = scriptObj.src;
        if (scriptObj.innerHTML)
            scriptElement.innerHTML = scriptObj.innerHTML;
        document.body.appendChild(scriptElement);
    });
};
var getHeaderKey = function (tenant, locale, headerType, hideSearch, hideVat, showStickyHeader) {
    return "".concat(REACT_COMP_VERSION, "_").concat(tenant, "_").concat(locale, "_header_").concat(headerType, "_hidesearch-").concat(hideSearch || false, "_hideVat-").concat(hideVat || false).concat(showStickyHeader ? "_showStickyHeader-true" : "").toLowerCase();
};
var getFooterKey = function (tenant, locale, footerType) {
    return "".concat(REACT_COMP_VERSION, "_").concat(tenant, "_").concat(locale, "_footer_").concat(footerType).toLowerCase();
};
var makeFileRequest = function (stagingContent, filePath) {
    var url = stagingContent ?
        "https://bookends-html-dev.s3.eu-west-1.amazonaws.com".concat(filePath.replace(/^((\/esi)|(\/html))/, "")) :
        "https://bookends.cdn.vpsvc.com".concat(filePath);
    return fetch(url)
        .then(function (response) {
        if (!response.ok) {
            throw new Error("Request failed with response code ".concat(response.status));
        }
        return response.text();
    })
        .catch(function (ex) {
        Logger.instance.error("Failed to add header bundle on client", {
            contextData: {
                message: ex.message,
                error: ex,
                url: url
            }
        });
        return "";
    });
};

export { addScriptsToDocument, getFooterKey, getHeaderKey, makeFileRequest };
//# sourceMappingURL=helpers.js.map
